import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from "angular2-notifications";

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: "app-otros-pagos-formulario",
  templateUrl: "./formulario.component.html"
})
export class OtrosPagosComponent implements OnInit{
  @Input() persona: string= '';
  dato: FormGroup = this.fb.group({});
  form_pagos: any;
  form_movimientos_articulos: any;
  cargando = false;
  movimientos_articulos: any;
  codigo_barras_activo = false;
  caja_abierta = false;
  stocks = [];
  auto = 0;
  ticket : any;
  error_venta = false;
  venta_ok = false;
  json: any;
  factura: any;
  reimprimir = false;
  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  public articulos_term: string = `${environment.API_URL}/articulos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal}`;

  tieneid: boolean = false;
  time_cambio_cantidad_stoc: any;
  time_cambio_cantidad_articulo_key: any;
  time_pago: any ;
  tamano = document.body.clientHeight;

  public startValue: string = '';
  public selected: string = '';
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  url_nuevo = "../../nuevo";
  lista_colas = false;
  subtotal = 0;
  descuento = 0;
  iva = 0;
  total = 0;
  total_recibido = 0;
  cambio = 0;

  usuario: any;
  caja: any = '';
  busqueda: string = '';
  objeto = {
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 3000
  };

  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private http: HttpClient,
    private notificacion: NotificationsService
  ) {}

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/articulos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`;
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit(): void {
    // obtener los datos del usiario logueado almacen y clues
    let u:any = localStorage.getItem("usuario");
    this.usuario = JSON.parse(u);
    this.caja = localStorage.getItem("caja");

    if (this.caja != '') {
      this.caja_abierta = true;
    }
    // inicializar el formulario reactivo
    this.dato = this.fb.group({
      id: [""],
      tipos_movimientos_id: [2],
      personas_id: [this.persona],
      subtotal: [0],
      descuento: [0],
      iva: [0],
      cajas_id: [""],
      total: [0, [Validators.required]],
      total_recibido: [0, [Validators.required]],
      cambio: [""],
      codigo: [""],
      folio: [""],
      barcode: [""],
      status_movimientos_id: [1],
      status_introduccion: [""],
      status_pago: [""],
      fecha: [""],
      created_at: [""],
      creado_por: [""],
      comentarios: [""],
      cola: [""],
      valido: ["", [Validators.required]],
      devoluciones: this.fb.array([]),
      pagos: this.fb.array([]),
      movimientos_articulos: this.fb.array([]),
      usuarios: this.fb.group({
        id: [""],
        nombre: [""]
      })
    });

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;

        this.dato.controls.created_at.valueChanges.subscribe(val => {
          if (val) {
            setTimeout(() => {
              this.reimprimir = true;
              this.json = this.dato.getRawValue();
              this.calcular_importe_articulo();
            }, 500);
          }
        });
      }
    });
    this.selected = "";
    this.startValue = "";
    // variable para crear el array del formulario reactivo
    this.form_pagos = {
      pagos_targetas: this.fb.group({
        banco: [""],
        folio: [""]
      }),
      tipos_metodos_pagos_id: ["PUE", [Validators.required]],
      tipos_formas_pagos_id: ["01", [Validators.required]],
      importe: [this.dato.controls["total"].value, [Validators.required]],
      paga_con: ["", [Validators.required]],
      cambio: ["", [Validators.required]],
      comentarios: [""]
    };

    this.form_movimientos_articulos = {
      articulos_id: ["", [Validators.required]],
      cantidad: ["", [Validators.required]],
      precios_unitario: ["", [Validators.required]],
      articulos_precios_id: [],
      importe: ["", [Validators.required]],
      descuento: ["", [Validators.required]],
      precio_con_descuentos: ["", [Validators.required]],
      iva_porcentaje: ["", [Validators.required]],
      iva_cantidad: ["", [Validators.required]],
      subtotal: ["", [Validators.required]]
    };
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    (<HTMLInputElement>document.getElementById("catalogosVenta")).click();
    setTimeout(() => {
      (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).focus;
    }, 100);
  }

  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.nombre}
            <small style="font-size: .5em; font-style: italic;">
            ${data.categorias ? data.categorias.nombre : "Ninguna"}
            </small></h4>
            <h6>
              <strong>Clave: </strong> ${
                data.clave
              } <strong>Codigo de barras: </strong> ${data.codigo_barras}
              `;
    html += `<label class="tag is-success" >Presentacion: ${
      data.presentaciones ? data.presentaciones.nombre : "Ninguna"
    } </label>`;

    html += `<label class="tag is-success" >Unidad medida: ${
      data.unidades_medidas ? data.unidades_medidas.nombre : "Ninguna"
    } </label>`;

    html += `<label class="tag is-warning" >Existencia : ${
      data.existencia
    }</label>`;

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  cambiar_precio(p:any, i:any, modelo:any) {
    p = p.srcElement.value;
    modelo[i].controls["precio_unitario"].patchValue(
      modelo[i].get("articulos").value.articulos_precios[p].precio
    );
    this.calcular_importe_articulo();
  }
  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data:any) {
    this.venta_ok = false;
    this.cargando = true;
    this.auto = 0;
    // obtener el formulario reactivo para agregar los elementos
    const control = <FormArray>this.dato.controls["movimientos_articulos"];

    // comprobar que el articulo no este en la lista cargada
    let existe = false;
    let i = 0;
    for (let item of control.value) {
      if (item.articulos_id == data.id) {
        existe = true;
        const imp:any = <FormArray>control.controls[i];
        imp.controls["cantidad"].patchValue(item.cantidad + 1);
        imp.controls["cantidad_restante"].patchValue(
          imp.controls["cantidad"].value
        );
        break;
      }
    }

    // crear el json que se pasara al formulario reactivo tipo articulos
    let precio = 0;
    let precio_id = null;
    if (data.articulos_precios.length > 0) {
      precio = data.articulos_precios[0].precio;
      precio_id = data.articulos_precios[0].id;
    }
    let movimientos_articulos = {
      articulos_id: [data.id, [Validators.required]],
      cantidad: [1, [Validators.required]],
      cantidad_restante: [1],
      precio_unitario: [precio, [Validators.required]],
      articulos_precios_id: [precio_id, [Validators.required]],
      importe: [precio, [Validators.required]],
      descuento: [0, [Validators.required]],
      precio_con_descuentos: [precio, [Validators.required]],
      iva_porcentaje: [0, [Validators.required]],
      iva_cantidad: [0, [Validators.required]],
      subtotal: [precio, [Validators.required]],
      stocks: this.fb.array([]),
      articulos: data
    };

    // si no esta en la lista agregarlo
    if (!existe) {
      control.insert(0, this.fb.group(movimientos_articulos));
    }
    //control.push(this.fb.group(movimientos_articulos));

    this.calcular_importe_articulo();

    this.options = {
      position: ["top", "right"],
      timeOut: 5000,
      lastOnBottom: true
    };

    if (data.stocks.length > 0) {
      let existencia = 0;
      data.stocks.forEach(element => {
        existencia += element;
      });
      if (data.cantidad > existencia) {
        this.notificacion.alert(
          "Cantidad Excedida",
          "La cantidad maxima es: " + existencia,
          this.objeto
        );
      }

      (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).value = "";
    } else {
      this.notificacion.alert(
        "¡No ha inicializado inventario!",
        "Es necesario inicializar en el módulo de inicialización o hacer una compra",
        this.objeto
      );
    }
    this.cargando = false;
  }

  calcular_importe_articulo() {
    // sumamos las cantidades
    let total = 0;
    let c = 0;
    let restante = 0;
    let descuento = 0;

    let movimientos_articulos:any = this.dato.get("movimientos_articulos");
    movimientos_articulos.value.forEach(element => {
      let importe_desc = element.cantidad * element.precio_unitario;
      element.importe = element.cantidad * element.precio_unitario;
      if (element.descuento > 0) {
        let desc = element.descuento / 100;
        element.precio_con_descuentos = importe_desc - importe_desc * desc;
        descuento += importe_desc * desc;
      } else {
        element.precio_con_descuentos = element.importe;
      }

      total = total + element.cantidad * element.precio_unitario;
      const ma = <FormArray>this.dato.controls.movimientos_articulos;
      const it:any = <FormGroup>ma.controls[c];
      it.controls.importe.patchValue(element.importe);
      it.controls.precio_con_descuentos.patchValue(
        element.precio_con_descuentos
      );
      c++;
      if (
        element.cantidad_restante != 0 &&
        it.controls.stocks["controls"].length > 0
      ) {
        restante++;
      }
    });

    let importe = 0;
    let cambio = 0;
    let i = 0;
    const pagos = <FormArray>this.dato.controls["pagos"];
    let dato_pagos :any = this.dato.get("pagos");
    dato_pagos.value.forEach(element => {
      importe = importe + element.paga_con;
    });

    this.dato.controls["subtotal"].patchValue(total);
    this.dato.controls["descuento"].patchValue(descuento);
    this.dato.controls["total"].patchValue(total - descuento);
    this.dato.controls["total_recibido"].patchValue(importe);

    let cambiox = importe - (total - descuento);
    if(cambiox < 0) {
      cambiox = 0;
    }
    this.dato.controls["cambio"].patchValue(cambiox);

    if (this.json) {
      this.json.subtotal = total;
      this.json.descuento = descuento;
      this.json.total = total - descuento;
      this.json.total_recibido = importe;
      this.json.cambio = cambiox;
    }

    if (importe >= total - descuento) {
      this.dato.controls["valido"].patchValue("si");

      if (restante > 0) {
        this.dato.controls["valido"].patchValue("");
        this.notificacion.alert(
          "Cantidad surtida",
          "Verifique que las cantidades coincidan con lo solicitado: ",
          this.objeto
        );
      }
    } else {
      this.dato.controls["valido"].patchValue("");
    }

    const imp = <FormGroup>pagos.controls[pagos.controls.length - 1];
    if (imp) {
      const pago:any = <FormArray>this.dato.controls.pagos;
      let p = pago.length - 1;
      if (p > 0) {
        pago.controls[p]["controls"]["importe"].patchValue(
          Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
        );
      } else {
        if (imp.controls.paga_con.value == "") {
          imp.controls.importe.patchValue(total - descuento);
        }
      }
    }
    let cambios = total - descuento;
    let dato_pago:any = this.dato.get("pagos");
    dato_pago.value.forEach(element => {
      const imp = <FormGroup>pagos.controls[i];
      if (element.paga_con > 0) {
        cambios = element.paga_con - cambios;
      }
      imp.controls["cambio"].patchValue(cambios);
      i++;
      cambios = Math.abs(cambios);
    });
  }

  // lote
  seleccionar_stock(item:any, i: number) {
    this.stocks = [];
    item.forEach(element => {
      element.posicion = i;
      this.stocks.push(element);
    });
  }
  agregar_stock(item:any) {
    let existe = false;
    const imp = <FormArray>this.dato.controls.movimientos_articulos;
    const art = <FormGroup>imp.controls[item.posicion];
    const stk = <FormArray>art.controls.stocks;

    let x = 0;
    stk.controls.forEach(ite => {
      if (ite.value.lote == item.lote) {
        existe = true;
        const stc = <FormGroup>stk.controls[x];
        stc.controls.cantidad.patchValue(stc.controls.cantidad.value + 1);
        return;
      }
      x++;
    });

    const ar = <FormArray>this.dato.controls.movimientos_articulos;
    const po = <FormGroup>ar.controls[item.posicion];
    const st = <FormArray>po.controls.stocks;

    if (!existe) {
      item.cantidad = [1, Validators.required];
      st.push(this.fb.group(item));
      if (item.precio > 0 && po.controls.precio_unitario.value <= 0) {
        po.controls.precio_unitario.patchValue(item.precio);
      }
      x = st.controls.length - 1;
    }

    this.cambio_cantidad_stock(po.controls, st.controls, x);

    (<HTMLInputElement>document.getElementById("cancelar_stock")).click();
  }
  quitar_stock(modelo:any, x:any, i:any, val:any) {
    modelo.removeAt(x);
    const ar = <FormArray>this.dato.controls.movimientos_articulos;
    const po = <FormGroup>ar.controls[i];
    const st = <FormArray>po.controls.stocks;
    po.controls.precio_unitario.patchValue(0);
    if (st.controls.length <= 0) {
      po.controls.cantidad_restante.patchValue(po.controls.cantidad.value);
    }
    st.controls.forEach(stock => {
      this.cambio_cantidad_stock(po.controls, stock["controls"]);
    });
  }

  cambio_cantidad_stock(articulos:any, stocks:any, pos: number = null ) {
    let total_surtido = 0;
    let restante = parseFloat(articulos.cantidad.value);
    if (pos != null && stocks.length) {
      setTimeout(() => {
        let existencia = parseFloat(stocks[pos].controls.existencia.value);

        stocks.forEach(element => {
          total_surtido =
            total_surtido + parseFloat(element.controls.cantidad.value);
        });
        restante = restante - total_surtido;

        if (stocks[pos].controls.cantidad.value <= 0) {
          stocks[pos].controls.cantidad.patchValue(1);
        }

        if (stocks[pos].controls.cantidad.value > existencia) {
          this.notificacion.alert(
            "Stock Excedido",
            "la existencia del stock es: " + existencia,
            this.objeto
          );
        } else if (total_surtido > articulos.cantidad.value) {
          this.notificacion.alert(
            "Cantidad Excedida",
            "La cantidad por surtir es: " + articulos.cantidad.value,
            this.objeto
          );
        }

        articulos.cantidad_restante.patchValue(restante);
      }, 100);
    } else {
      stocks.forEach(element => {
        total_surtido =
          total_surtido + parseFloat(element.controls.cantidad.value);
      });
      restante = restante - total_surtido;
      articulos.cantidad_restante.patchValue(restante);
    }
    if (restante == 0) {
      this.dato.controls["valido"].patchValue("si");
    } else {
      this.dato.controls["valido"].patchValue("");
    }
  }

  cambio_cantidad_stock_key(event:any, articulos:any, stocks:any, pos:number) {
    if (event.key == "Backspace" || event.key == "Delete") {
      this.calcular_importe_articulo();
    }
    if (
      event.key != "Backspace" &&
      event.key != "Delete" &&
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cambio_cantidad_stoc);
      this.time_cambio_cantidad_stoc = setTimeout(() => {
        this.cambio_cantidad_stock(articulos, stocks, pos);
      }, 800);
    }
  }

  cambio_cantidad_articulo(articulo:any) {
    articulo.cantidad_restante.patchValue(articulo.cantidad.value);
    let pos = 0;

    this.cambio_cantidad_stock(articulo, articulo.stocks.controls, pos);

    this.calcular_importe_articulo();
  }

  cambio_cantidad_articulo_key(event:any, articulos:any) {
    if (event.key == "Backspace" || event.key == "Delete") {
      this.calcular_importe_articulo();
    }

    if (
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cambio_cantidad_articulo_key);
      this.time_cambio_cantidad_articulo_key = setTimeout(() => {
        this.cambio_cantidad_articulo(articulos);
      }, 800);
    }
  }
  // fin lote

  buscar_articulo(e:any) {
    if (e.keyCode == 13) {
      let valor = (<HTMLInputElement>document.getElementById('buscarArticuloVenta'))
        .value;
      (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).value = "";
      (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).focus;
      let este = this;
      this.cargando = true;
      this.crudService.ver(valor, "articulos").subscribe(
        resultado => {
          este.select_articulo_autocomplete(resultado.data);
          este.cargando = false;
        },
        error => {}
      );
    }
  }

  cambiar_busqueda() {
    this.auto = 0;
    this.codigo_barras_activo = !this.codigo_barras_activo;
    (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).value = "";
    (<HTMLInputElement>document.getElementById('buscarArticuloVenta')).focus;
  }

  agregar_forma_pago(modelo: FormArray, formulario:any) {
    (<FormArray>modelo).push(this.fb.group(formulario));

    const pago:any = <FormArray>this.dato.controls.pagos;

    let p = pago.length - 1;
    if (p > 0) {
      pago.controls[p]["controls"]["importe"].patchValue(
        Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
      );
    }
  }

  validar_cantidad_pago(event:any, modelo:any, cantidad:any, tipo:any, i:number) {
    if (
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_pago);
      this.time_pago = setTimeout(() => {
        this.validar_pago(event, modelo, cantidad, tipo, i);
      }, 1000);
    }
  }
  validar_pago(event:any, modelo:any, cantidad: any, tipo: any, i: number) {
    let success = true;

    if (tipo == "max") {
      if (modelo.value > cantidad) success = false;
    }
    if (!success) modelo.patchValue(cantidad);

    this.calcular_importe_articulo();
  }
  reset_form() {
    this.selected = "";
    this.startValue = "";
    this.dato.reset();
    for (let item in this.dato.controls) {
      const ctrl = <FormArray>this.dato.controls[item];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
    }
    this.dato.controls.tipos_movimientos_id.patchValue(2);
    this.dato.controls.status_movimientos_id.patchValue(1);
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );
  }

  enviar() {
    this.cargando = true;
    if(this.persona)
      this.dato.controls.personas_id.patchValue(this.persona);
    this.json = this.dato.getRawValue();
    if (this.dato.get("id").value > 0) {
      
      this.crudService
        .editar(this.dato.get("id").value, this.json, "venta")
        .subscribe(
          resultado => {
            this.enviar_ticket(this.json, resultado);
          },
          error => {
            this.cargando = false;
            this.error_venta = true;
          }
        );
    } else {
      this.crudService.crear(this.json, "venta").subscribe(
        resultado => {
          this.enviar_ticket(this.json, resultado);
          this.reset_form();
        },
        error => {
          this.cargando = false;
          this.error_venta = true;
          setTimeout(() => {
            this.error_venta = false;
          }, 2500);
        }
      );
    }
  }

  enviar_ticket(json:any, resultado:any) {
    this.cargando = false;
    this.reimprimir = true;
    this.venta_ok = true;
    this.cajero = "";
    this.nombreCajero = "";
    (<HTMLInputElement>document.getElementById("quitar_cola")).click();
    setTimeout(() => {
      this.venta_ok = false;
    }, 3000);
    this.json = resultado.data;
    if(document.getElementById("traerFactura")){
      this.factura = resultado.data.facturacion;
      (<HTMLInputElement>document.getElementById("traerFactura")).click();
    }
    this.calcular_importe_articulo();
    this.error_venta = false;
    if (JSON.parse(localStorage.getItem("configuracion")).sucursal.recibo) {
      setTimeout(() => {
        (<HTMLInputElement>document.getElementById("imprimir_ticket")).click();
      }, 200);
    }
    setTimeout(() => {
      this.venta_ok = false;
    }, 1500);
  }

  sin_resultado = "";
  enviar_correo(imprimir = false) {
    this.cargando = true;
    let json = this.dato.value;
    json.imprimir = imprimir;

    this.crudService.crear(json, "enviar-presupuesto").subscribe(
      resultado => {
        if (resultado.status == 200) {
          if (imprimir) {
            window.open(resultado.data, "_blank");
          }
        }
        this.sin_resultado = resultado.messages;
        this.cargando = false;

        setTimeout(() => {
          this.sin_resultado = "";
        }, 3500);
        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    );
  }


  cajero:any;
  nombreCajero = "";
  buscarCajero(){
    this.cargando = true;
    let json: any = {
      clave: this.cajero
    };
    this.crudService.crear(json, "usuario-venta").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200) {
          this.dato.controls.creado_por.patchValue(resultado.data.id);
          this.nombreCajero = resultado.data.nombre;
        }else{
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = "";
          }, 3500);
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }

  asignarPersona(persona:any) {
    console.log('METODO asignarPersona :');
    console.log(persona);
    console.log('FIN METODO asignarPersona');

    this.persona = persona;
    this.dato.controls.personas_id.patchValue(persona);
  }

  devolverFactura(){
    let facturacion:any = [];
    facturacion["status"] = 200;
    facturacion["facturacion"] = this.factura;
    return facturacion;
  }
}
 